import { useEffect, useState } from 'react';
import Stat from '../../components/ui/Stat';
import Table from '../../components/ui/Table';
import { request } from '../../services/api';

export default function DashboardPage({ token }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    request('/api/contracts/dashboard', { token }).then((response) => setStats(response.data)).catch(console.error);
  }, [token]);

  if (!stats) return <div className="empty">Loading dashboard...</div>;

  return (
    <div className="stack">
      <div className="stats-grid">
        <Stat label="Total" value={stats.total_contracts} />
        <Stat label="Pending" value={stats.pending_contracts} />
        <Stat label="Viewed" value={stats.viewed_contracts} />
        <Stat label="Signed" value={stats.signed_contracts} />
        <Stat label="Rejected" value={stats.rejected_contracts} />
        <Stat label="Contacts" value={stats.total_contacts} />
      </div>
      <div className="split">
        <Table title="Recent contracts" rows={stats.recent_contracts} columns={['title', 'recipient_email', 'status']} />
        <Table title="Recent signers" rows={stats.recent_signers} columns={['full_name', 'email', 'total_signed_contracts']} />
      </div>
    </div>
  );
}
